import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

//Get the button
let backToTopBtn = document.getElementsByClassName("ab-back-to-top");

// When the user clicks on the button, scroll to the top of the document
backToTopBtn.forEach(backToTopBind)

function backToTopBind(item){
	item.addEventListener("click", backToTop);

}

function backToTop() {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
}